import { useEffect, useState } from "react";
import DataTable from "../../../Templets/DataTable/DataTable";
import Button from "../../Button/Button";
import Reactportal from "../../Reactportal/Reactportal";
import "./AddUserPaymentTerms.scss";

const ShowUserPaymentIDS = ({ getUserPaymentManagementWithIdId, ClosePaymentTermsIDS, show, ShowData }) => {
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [toggle, setToggle] = useState(show);
  useEffect(() => {
    let GetPaymentTermsValues = getUserPaymentManagementWithIdId?.map((item, index) => {
      return {
        Name: item?.Name,
        id: item?.id,
      };
    });
    setPaymentTerms(GetPaymentTermsValues);
  }, [getUserPaymentManagementWithIdId]);

  return (
    <>
      {
        <div>
          <Reactportal
            open={toggle}
            onClose={ClosePaymentTermsIDS}
            TypeOfPortal={"Payment Terms Master Id"}
          >
            <div className="PaymentTermsData">
              {!paymentTerms?.length ? (
                <p>Data not Avaliable</p>
              ) : (
                <DataTable
                  ledger=""
                  title={"New Branches"}
                  formdata={paymentTerms}
                  loading={false}
                  error={false}
                  length={paymentTerms?.length}
                  crSum={0}
                  drSum={0}
                  roletable={false}
                  selectedRows={false}
                  dragDiv={""}
                />
              )}
            </div>
            <div className="PaymentsFooter">
              <Button
                action={ClosePaymentTermsIDS}
                text={"Close"}
                name={"CloseShowIDs"}
                type={""}
                children={""}
                disabled={""}
              />
            </div>
          </Reactportal>
        </div>
      }
    </>
  );
};

export default ShowUserPaymentIDS;
